import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import Select from '../../../dev/Select'
// import 'react-select/dist/react-select.css';

const CategorySearch = (props) => {
    const { categorySelect, messages } = props
    const categoryOptions = [
        { value: "", label: 'All', clearableValue: false },
        { value: "Autos & Vehicles", label: messages.info_list_type_autos, clearableValue: false },    
        { value: "Comedy", label: messages.info_list_type_comedy, clearableValue: false },    
        { value: "Education", label: messages.info_list_type_education, clearableValue: false },    
        { value: "Entertainment", label: messages.info_list_type_entertainment, clearableValue: false },    
        { value: "Film & Animation", label: messages.info_list_type_film, clearableValue: false },    
        { value: "Gaming", label: messages.info_list_type_gaming, clearableValue: false },    
        { value: "Howto & Style", label: messages.info_list_type_howto, clearableValue: false },    
        { value: "Music", label: messages.info_list_type_music, clearableValue: false },    
        { value: "News & Politics", label: messages.info_list_type_news, clearableValue: false },    
        { value: "Nonprofits & Activism", label: messages.info_list_type_nonprofits, clearableValue: false },    
        { value: "People & Blogs", label: messages.info_list_type_people, clearableValue: false },    
        { value: "Pets & Animals", label: messages.info_list_type_pets, clearableValue: false },    
        { value: "Science & Technology", label: messages.info_list_type_science, clearableValue: false },    
        { value: "Shows", label: messages.info_list_type_shows, clearableValue: false },    
        { value: "Sports", label: messages.info_list_type_sports, clearableValue: false },    
        { value: "Travel & Events", label: messages.info_list_type_travel, clearableValue: false },    
    ]
    return (
        <CountryWrap>
            <Title>{messages.info_topic}：</Title>
            <Select
                onChange={categorySelect}
                options={categoryOptions}
                placeholder={'All'}
            />
        </CountryWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(CategorySearch);
const Title = styled.div`
    margin-right: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    color: #979797;
`
const CountryWrap = styled.div`
    display: flex;
    align-items: center;    
    margin: 20px 20px 0 0;
`


// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/CategorySearch.js